<template>
  <div class="tabs" :class="{ 'tabs--wide': wide }">
    <div class="tabs__head">
      <div class="tabs__head-scroll">
        <div class="tabs__head-inner">
          <template v-for="tab in props.tabList">
            <slot
              :name="tab"
              :active="tab === props.value"
              :onSelect="() => handleSelect(tab)"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  value: string;
  tabList: string[];
  wide?: boolean;
}

const props = defineProps<Props>();
const emit = defineEmits<{
  (event: "onSelect", tab: string): void;
}>();

const handleSelect = (tab: string) => {
  emit("onSelect", tab);
};
</script>

<style lang="scss" scoped>
.tabs {
  &__head {
    display: flex;
    justify-content: center;
    padding: rem(16) 0;
    margin-bottom: rem(4);
  }

  &__head-scroll {
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    margin: 0 rem(-16);
  }

  &__head-inner {
    /** START: Quick-fix to display items on new line, if tab title is too long **/
    /*display: inline-flex;*/
    /*justify-content: center;*/
    display: block;
    text-align: center;
    /** END of quick-fix **/
    margin: auto;
    padding: 0 rem(16);
  }

  @media screen and (max-width: $screen-md-min) {
    &.tabs--wide &__head-scroll {
      width: 100%;
    }
  }

  &.tabs--wide &__head-inner {
    display: flex;
    padding: 0;
    flex-wrap: wrap;
    column-gap: 4px;
  }

  &.tabs--wide &__toggle {
    margin-left: 0;
    flex: 1;
    justify-content: center;
  }

  @media screen and (min-width: $screen-lg-min) {
    &__head {
      margin-bottom: rem(16);
    }
  }
}
</style>
